import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Forgetpassword, resetLogin } from "../../redux/authSlice";
import { Link, useNavigate } from "react-router-dom";
import { Backarrow } from "../../icons/icons";
import { Facebook } from "../../icons/icons";
import Logo from "../../assets/images/login/logo.png";
import {
  TextField,
  Button,
  IconButton,
  Typography,
  Box,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
} from "@mui/material";
import Grid from "@mui/system/Grid";
import Stack from "@mui/system/Stack";
import AgreeSec from "../agree-sec";

function ForgetPassword() {
  const [email, setEmail] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { forgetpass } = useSelector((state) => state.admin);
  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const validateForm = () => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      await dispatch(Forgetpassword(email));
      dispatch(resetLogin());
    } else {
      console.log("Please enter valid data.");
    }
  };

  useEffect(() => {
    if (forgetpass) {
      navigate("/forgetpasswordotp");
    }
  }, [navigate, forgetpass]);

  return (
    <Box className="login-wrapper">
      <Grid container spacing={{ xs: 0, sm: 2 }} sx={{ height: { xs: 'auto', md: "100%" } }}>
      <Grid size={{ xs: 12, md: 6, xl:5, xxl:6 }}>
          <Box sx={{ m: { xs: '20px', sm: '32px', md: '32px 80px' } }}>
            <img src={Logo} alt="logo" />
          </Box>
        </Grid>

        <Grid size={{ xs: 12, md: 6,xl: 7, xxl:6 }}>
          <Stack sx={{ height: { xs: '85vh', md: "100%" }, width: { xs: '90%', sm: '70%', md: '50%',xl:'60%', xxl:'50%' }, margin: '0 auto', position: 'relative' }} justifyContent={{ xs: 'center', md: "start" }} alignItems={'center'}>
                <Box sx={{ width: '100%', paddingTop: { xs: '0', sm: '50px', xl: '50px', xxl: '100px' } }}>
              <Typography
                variant="h1"
                sx={{ color: "#fff", fontSize: "40px", fontWeight: "700" }}
                fullWidth
              >
                Forgot Password
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  color: "#CBD2E2",
                  fontSize: "16px",
                  fontWeight: "500",
                  mt: "12px",
                  mb: "28px",
                }}
              >
                Please enter your registered Email ID to receive
                an OTP for password reset.
              </Typography>
            </Box>

            <Box
              component="form"
              onSubmit={handleSubmit}
              sx={{ width: "100%" }}
            >
              <FormControl fullWidth sx={{ mb: 2 }}>
                <OutlinedInput
                  name="email"
                  placeholder="Please enter your registered email id"
                  value={email}
                  onChange={handleChange}
                  className="custom-input"
                  sx={{ color: "#fff" }}
                />
              </FormControl>

              <Button
                type="submit"
                variant="contained"

                color="primary"
                fullWidth
                sx={{ mb: { xs: 1, xl: 2 }, p: { xs: '6px', xl: '10px' }, backgroundColor: 'primary.Main', fontSize: '18px', fontWeight: '500', borderRadius: '50px', height: 'auto' }}
              >
                Send OTP
              </Button>
              <Typography
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  color: "#84A1D6",
                  textAlign: "center",
                  cursor: "pointer",
                  textDecoration: "none",


                }}
                component={Link}
                to="/login"
              >
                <Box sx={{ pr: 2 }}>      <Backarrow /></Box>
                back to login
              </Typography>

            </Box>

            <AgreeSec />
          </Stack>
        </Grid>
      </Grid>
    </Box>

    // <div className="min-h-screen flex items-center justify-center bg-gray-900">
    //   <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full">
    //     <div className="flex flex-col items-center mb-6">
    //       {/* Logo or Illustration */}
    //       <div className="text-6xl text-blue-600 mb-4">AI</div>
    //       <h2 className="text-2xl font-semibold text-gray-800">Forgot Password</h2>
    //       <p className="text-gray-600 text-center">
    //         Please enter your registered Email ID or Mobile Number to receive an OTP for password reset.
    //       </p>
    //     </div>

    //     <form onSubmit={handleSubmit}>
    //       <div className="mb-4">
    //         <input
    //           type="email"
    //           placeholder="Email or Mobile Number"
    //           value={email}
    //           onChange={handleChange}
    //           required
    //           className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500"
    //         />
    //       </div>

    //       <button
    //         type="submit"
    //         className={`w-full bg-blue-600 text-white p-3 rounded-lg
    //         hover:bg-blue-700 transition duration-300 ${email ? "" : "opacity-50"}`}
    //               >
    //                   Send OTP
    //       </button>
    //     </form>
    //   </div>
    // </div>
  );
}

export default ForgetPassword;
